import Actions              from 'Redux/Actions';
import { AppUserRepository } from 'Domain/Repositories';
import { ofType }           from 'redux-observable';
import { from }             from 'rxjs';
import { mergeMap }         from 'rxjs/operators';
import { TEpic }            from 'Redux/Config';

export const assignAppUserEventsEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.assignAppUserEventsRequest.type),
    mergeMap(action => from(
      AppUserRepository.updateEvents(action.payload)
        .then(({ eventIds }: { eventIds: string[] }) => Actions.assignAppUserEventsSuccess({ organisationId: action.payload.organisationId, eventIds }))
        .catch((error: Error) => Actions.assignAppUserEventsFailure({ error })),
    )),
  );
};
